"use client";

import About from "./_components/about";
import HomeBanner from "./_components/banner";
import Services from "./_components/services";
import Standards from "./_components/standards";
import Trip from "./_components/trip";

const HomePage = () => {

	return (
		<>
			<HomeBanner />

			<Trip />

			<About />

			<Services />

			<Standards />
		</>
	);
};

export default HomePage;
